@if (loggedIn) {
  <div class="holder">
    @if (type=='scans') {
      <table class="maintable">
        <thead>
          <tr>
            <th style="width:25%">{{strings.artesStrings['SIGNED_CERTIFICATE']}}</th>
            <th style="width:15%" (click)="sortScans('uploaded')">{{strings.artesStrings['REGISTERED']}}</th>
            <th style="width:40%">{{strings.artesStrings['ASSIGN_CERTIFICATE_HOLDER']}}</th>
            <th style="width:10%"></th>
            <th style="width:10%"></th>
          </tr>
        </thead>
        @for (scan of eventsService.scans; track scan) {
          <tbody>
            <tr>
              <td class="btnholder"><button (click)="streamScan(scan.name)">{{strings.artesStrings['CERTIFICATE']}}</button></td>
              <td>{{dateFormat.dateToStr(scan.uploaded)}}</td>
              <td class="btnholder">
                <mat-select [(value)]="scan.assignedPerson">
                  <mat-option [value]="null"></mat-option>
                  @for (person of (constantsService.observeConstants() | async)?.holders; track person) {
                    <mat-option [value]="person.id">{{person.full_name}} - {{person.license.license_number}}</mat-option>
                  }
                </mat-select>
                <!--<ng-select [items]="constantsService.constants.people"
                bindLabel="full_name"
                bindValue="id"
                placeholder="{{strings['ASSIGN_CERTIFICATE_HOLDER']}}"
                [loading]="constantsService.isLoading"
                [(ngModel)]="scan.assignedPerson">
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  <span style="float:left;">{{item.full_name}}</span>
                  <b style="float:right;">{{item.license.license_number}}</b>
                </ng-template>
              </ng-select>-->
            </td>
            <td class="btnholder"><button (click)="respondScan(scan.name, 1, scan.assignedPerson)">{{strings.artesStrings['ACCEPT']}}</button></td>
            <td class="btnholder reject"><button (click)="respondScan(scan.name, 2)">{{strings.artesStrings['REJECT']}}</button></td>
          </tr>
        </tbody>
      }
    </table>
  }
  @if (type=='reported-issues') {
    <table class="maintable">
      <tr>
        <th style="width:18%" (click)="sortIssues('openedTime')">{{strings.artesStrings['REGISTERED']}}</th>
        <th style="width:18%" (click)="sortIssues('name')">{{strings.artesStrings['NAME']}}</th>
        <th style="width:18%" (click)="sortIssues('licenseNumber')">{{strings.artesStrings['LICENSE_NUMBER']}}</th>
        <th style="width:18%" (click)="sortIssues('comment')">{{strings.artesStrings['COMMENT']}}</th>
        <th style="width:18%">{{strings.artesStrings['REPLY_TO_CASE']}}</th>
        <th style="width:10%"></th>
      </tr>
      @for (report of eventsService.reports; track report) {
        <tbody>
          <tr>
            <td>{{dateFormat.dateToStr(report.opened_time, 'ddmmyyyyhhmm')}}</td>
            <td>{{report.opened_by_person.full_name}}</td>
            <td>{{report.opened_by_person.license.license_number}}</td>
            <td>{{report.comment}}</td>
            <td class="btnholder"><textarea [(ngModel)]="report.response"></textarea></td>
            <td class="btnholder"><button (click)="respondReport(report)">{{strings.artesStrings['FINISH']}}</button></td>
          </tr>
        </tbody>
      }
    </table>
  }
</div>
}
